import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'

export default {
  name: 'business',
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addBusiness({}, business) {
      const { data } = await defaultApi.postBusiness(business)
      return data
    },
    async modifyBusiness({}, { uuid, business }) {
      const { data } = await defaultApi.putBusiness(uuid, business)
      return data
    },
    async getBusinessOcr({}, file) {
      const { data } = await defaultV2Api.postBusinessOcr(file)
      return data
    },
  },
}
